module.exports = __webpack_public_path__ + "img/BE0415466440.fd398dc2.png";